export default __webpack_public_path__ + "static/lift_w.53d0e044983b89b8094b0c5d0e115e53.png";